/* eslint no-prototype-builtins: "off" */

/**
 * ContentRepository module
 *
 * This module create shortcut with a request
 * to the API
 *
 */

'use strict';

const RequestHandler = require('./../../../core/requestHandler');

const mandatoriesAttribute = ['login', 'email', 'firstname', 'lastname'];

module.exports.getCurrentUser = function() {
    return RequestHandler.read('user/current');
};

module.exports.findAll = function() {
    return RequestHandler.read('user');
};

module.exports.findBy = function(data) {
    return RequestHandler.read('user', data);
};

module.exports.delete = function(uid) {
    return RequestHandler.del('user/' + uid);
};

const isPutMethod = function(data) {
    let mandatory;

    for (let key = 0; key < mandatoriesAttribute.length; key++) {
        mandatory = mandatoriesAttribute[key];
        if (!data.hasOwnProperty(mandatory)) {
            return false;
        }
    }

    return true;
};

module.exports.save = function(data, uid) {
    let result;

    if (uid) {
        if (isPutMethod(data)) {
            result = RequestHandler.update('user/' + uid, data);
        } else {
            result = RequestHandler.patch('user/' + uid, data);
        }
    } else {
        result = RequestHandler.create('user', data);
    }

    return result;
};

module.exports.updatePassword = function(userId, password, newPassword, confirmPassword) {
    let currentApiUrl = RequestHandler.getBaseUrl();
    let dfd;

    let data = {
        'password': password,
        'new_password': newPassword,
        'confirm_new_password': confirmPassword,
    };

    RequestHandler.setBaseUrl('/api');

    dfd = RequestHandler.update('users/'+ userId +'/update-password', data);

    RequestHandler.setBaseUrl(currentApiUrl);

    return dfd;
};
